import { makeObservable, observable } from 'mobx'
import moment from 'moment'
import RuleGroup from '../../../ReportV2/components/Modal/Filter/model/RuleGroup'

class FeatureFlag {
    id

    @observable name

    @observable label

    @observable scope

    @observable active

    @observable description

    @observable updated

    @observable data

    constructor({
        id,
        name,
        label,
        scope,
        active,
        description,
        lastUpdated,
        userName,
        data,
    }) {
        this.id = id
        this.name = name
        this.label = label
        this.scope = scope
        this.active = active
        this.description = description
        this.updated = `${moment(lastUpdated).format('D MMMM YYYY')} · ${userName}`

        console.log('here', this.updated)

        this.data = data ?? {
            role: { logic: 'ignore', options: [] },
            addons: { logic: 'ignore', options: [] },
            combinator: 'AND',
            tags: new RuleGroup(),
        }

        makeObservable(this)
    }

    toggleGlobalRole = (role) => {
        let roles = this.data.role.options.slice()

        if (roles.includes(role)) {
            roles = roles.filter((r) => r !== role)
        } else {
            roles.push(role)
        }
        this.data.role.options = roles
    }

    toggleGlobalAddon = (addon) => {
        let addons = this.data.addons.options.slice()

        if (addons.includes(addon)) {
            addons = addons.filter((r) => r !== addon)
        } else {
            addons.push(addon)
        }
        this.data.addons.options = addons
    }

    getSummary = (scope, options = []) => {
        const { logic } = this.data[scope]
        const values = this.data[scope]?.options ?? []

        if (logic === 'ignore') {
            if (scope === 'role') return 'Every role passes'
            if (scope === 'addons') return 'Role addons are not checked'
        }

        console.log('getSummary', options)

        const prefix = logic === 'OR' ? 'Any of' : 'Every one of'
        const mappedValues = values.length === 0
            ? 'nothing selected'
            : values.map((v) => options.find(([o]) => o === v)?.[1] ?? v).join(', ')

        return `${prefix}: ${mappedValues}`
    }

    toJSON() {
        return {
            id: this.id,
            name: this.name,
            label: this.label,
            scope: this.scope,
            active: this.active,
            description: this.description,
            data: this.data,
        }
    }
}

export default FeatureFlag
